import React from 'react';
import CompanionsCityGrid from './CompanionsCityGrid';
import CompanionsRegionExplainer from './CompanionsRegionExplainer';
import CompanionsSpotlight from './CompanionsSpotlight';
import { formatFa } from './constants';
import type { CompanionCity, CompanionRegionFilter } from './types';

type CompanionsCityCardsSectionProps = {
  activeCity: CompanionCity;
  activeCityId: string;
  activeRegion: CompanionRegionFilter;
  filteredCities: CompanionCity[];
  onRegionChange: (region: CompanionRegionFilter) => void;
  onSelectCity: (cityId: string) => void;
  onOpenVideo: (city: CompanionCity) => void;
};

const CompanionsCityCardsSection: React.FC<CompanionsCityCardsSectionProps> = ({
  activeCity,
  activeCityId,
  activeRegion,
  filteredCities,
  onRegionChange,
  onSelectCity,
  onOpenVideo,
}) => (
  <section id="companions-city-stories" className="cp-stories-section">
    <div className="cp-stories-section__bg" aria-hidden />

    <header className="cp-stories-section__header">
      <div className="text-right">
        <p className="cp-stories-eyebrow">داستان شهرها</p>
        <h2 className="cp-stories-section__title">روایت‌هایی از مسیر واقعی همراهان</h2>
        <p className="cp-stories-section__lead">
          کارت را انتخاب کنید یا روی شهر در کره کلیک کنید — همان شهر در این بخش و روی نقشه فعال
          می‌شود.
        </p>
      </div>
      <div className="cp-stories-section__count">
        <span>{formatFa(filteredCities.length)}</span>
        <small>شهر</small>
      </div>
    </header>

    <CompanionsRegionExplainer
      activeRegion={activeRegion}
      filteredCount={filteredCities.length}
      onRegionChange={onRegionChange}
    />

    <CompanionsSpotlight city={activeCity} onOpenVideo={onOpenVideo} />

    <CompanionsCityGrid
      cities={filteredCities}
      activeCityId={activeCityId}
      onSelectCity={onSelectCity}
      onOpenVideo={onOpenVideo}
    />
  </section>
);

export default CompanionsCityCardsSection;
